__turbopack_context__.v({
  "deadlineBanner": "bXOB-G_deadlineBanner",
  "descriptionTextContainer": "bXOB-G_descriptionTextContainer",
  "disabled": "bXOB-G_disabled",
  "emptyMessage": "bXOB-G_emptyMessage",
  "participantList": "bXOB-G_participantList",
  "progressCircle": "bXOB-G_progressCircle",
  "stagingBanner": "bXOB-G_stagingBanner",
  "stickyHeader": "bXOB-G_stickyHeader",
  "titleWrapper": "bXOB-G_titleWrapper",
});
